import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        homeIndex: 0,
        pageCurrentIndex: 0,
        isMobile: 0,
        screenWidth:1920,
        homeData: {
            viewPointList:[],
            teamList: [],
            newsObj: {
                one:{},
                two:[]
            },
            homePortfolio:[],
            contactList:[],
            aboutInfo:{
                one:{},
                two:[]
            }
        },
        newsInfo:{},
        viewPointInfo:{},
        newsList:{
            total:0,
            list:[]
        },
        viewPointList:{
            total:0,
            list:[]
        },
        teamInfo:{

        },
        teamList:{
            total:0,
            list:[]
        },
        fGoHome:0,
    },
    mutations: {
        setScreenWidth(state,index){
            state.screenWidth = index;
        },
        setFGoHome(state, index){
            state.fGoHome = index;
        },
        setPageCurrentIndex(state, index) {
            state.pageCurrentIndex = index;
        },
        setIsMobile(state, index) {
            state.isMobile = index;
        },
        setHomeData(state, index) {
            state.homeData = index;
        },
        setNewsInfo(state,index){
            state.newsInfo = index;
        },
        setViewPointInfo(state,index){
            state.viewPointInfo = index
        },
        setNewsList(state,data){
            state.newsList = data
        },
        setViewPointList(state,data){
            state.viewPointList = data
        },
        setTeamInfo(state,index){
            state.teamInfo = index;
        },
        setTeamList(state,data){
            state.teamList = data
        },
        setHomeIndex(state,index){
            state.homeIndex = index
        }
    },
    actions: {
        setPageCurrentIndex({commit}, index) {
            commit('setPageCurrentIndex', index);
        },
        setIsMobile({commit}, index) {
            commit('setIsMobile', index);
        },
        setStoreByKeyData({commit}, data) {
            commit(data.key, data.data)
        }
    },
    getters: {
        pageCurrentIndex: state => state.pageCurrentIndex,
        isMobile: state => state.isMobile,
        homeData:state=>state.homeData,
        newsInfo:state=>state.newsInfo,
        newsList:state=>state.newsList,
        teamList:state=>state.teamList,
        teamInfo:state=>state.teamInfo,
        homeIndex:state=>state.homeIndex,
        fGoHome:state=>state.fGoHome,
        screenWidth:state=>state.screenWidth,
        viewPointInfo:state=>state.viewPointInfo,
        viewPointList:state=>state.viewPointList
    }
});
